



































































import { Component, Vue } from 'vue-property-decorator';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { AppModule } from '@/store/modules/app';
import ContactDetails from '@/components/Contacts/ContactDetails.vue';
import ContactStatus from '@/components/Contacts/Display/ContactStatus.vue';
import ContactStatusEdit from '@/components/Contacts/ContactStatusEdit.vue';
import ContactLocationsList from '@/components/Contacts/ContactLocationList.vue';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import EntityType from '@/models/Shared/EntityType';
import Notes from '@/components/Notes/Notes.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactWorkersList from '@/components/ContactWorkers/ContactWorkersList.vue';
import ActivityTimeline from '@/components/Activities/ActivityTimeline.vue';
import TaskGrid from '@/components/Activities/TaskGrid.vue';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';

@Component({
  name: 'Contact',
  components: { ContactDetails, ContactStatus, ContactStatusEdit, ContactLocationsList, ContactWorkersList, Notes, Alert, ActivityTimeline, TaskGrid }
})
export default class extends GiganautVue {

  entityType = EntityType.Contact;
  activityEntityType = ActivityEntityType.Contact;

  async created() {

  }

  get currentContact() {
    return ContactDetailsModule.currentContact;
  }

  get loading() {
    return ContactDetailsModule.loading;
  }

  async navigateToContactList() {
    this.$router.push({ name: PageNames.AgencyContacts});
    
  }
}
